if (!customElements.get("video-player")) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector("video");
      this.video.load();
      this.handleVideo();
    }
    /**
     * Handle video interaction
     */
    handleVideo() {
      // Loop sources
      this.querySelectorAll("source").forEach((source) => {
        source.src = source.dataset.src;
      });
    }
  }
  customElements.define("video-player", VideoPlayer);
}
